import React,{useState, useEffect} from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
import "../../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate } from 'react-router-dom'
import {sportlist} from '../../../apis/urls'
import axios from "axios";

const AddSports = () => {

    const [name,setName] = useState('');
    const [description,setDescription] = useState('');
    const [status,setStatus] = useState('');
    const [nameerror,setNameerror] = useState('');


    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/sportslist")
        
    }


    const onFormClick = () => {

        let error = 0;

        if(name === '')
        {
            setNameerror(true)
            error = 1;
        }

        if(error === 0)
        {

            let token = "Bearer "+localStorage.getItem('token');
            console.log(token)
            const data = {
                name :name,
                description :description,
                status :'ACTIVE'
            }
            
            const instance = axios.create({

                baseURL: sportlist,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.post('',data).then((response) =>{
                
                let path = 'newPath'; 
                navigate("/sportslist")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

                //setNameerror('Enter the Name')
                

            });
        }



    }


    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div class="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Add New Sports</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/sportslist">Sports</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add Sports</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                        <div className="form-wrpr">
                            <div className="card formcard small">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label className="degreehead">Name <span style={{color: "red"}}>*</span></label>
                                        <input type="text" className="form-control bg-dark dark-theme showtext" value={name} onChange={e => {setName(e.target.value)}} placeholder="Enter Sports Name" id="name"></input>
                                        
                                        {
                                            nameerror
                                            ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Name</div>
                                            :null
                                        }

                                    </div>
                                    <div className="form-group">
                                        <label className="degreehead">Description</label>
                                        <input type="text" className="form-control bg-dark dark-theme showtext" value={description} onChange={e => {setDescription(e.target.value)}} placeholder="Enter the Description" id="name"></input>
                                    </div>
                                    {/* <div className="form-group">
                                        <label className="degreehead">Status</label>
                                            <select onChange={e => {setStatus(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                                <option>Select Status</option>
                                                <option>ACTIVE</option>
                                                <option>INACTIVE</option>
                                                <option>DELETED</option>
                                                
                                            </select>
                                    </div> */}
                                    <h6 style={{color: "red"}}>* Required Fields</h6>
                                    
                                    <div className="form-group text-right">
                                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                        <button onClick={onFormClick} className="btn btn-primary btn-gisa" type="button">Create</button>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </form>


                </div>
            </aside>
        </div>
    )
}

export default AddSports;